import { PAYMENTS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import paymentsTypes from '../../constants/paymentsTypes'
import { axios } from '../../services'

// import { try_force_logoff } from '../auth'
//
const get_payment_request = () => {
  return {
    type: paymentsTypes.get.request
  }
}

const get_payment_success = (response) => {
  return {
    type: paymentsTypes.get.success,
    payload: response.data.payment
  }
}

const get_payment_failure = (messages) => {
  return {
    type: paymentsTypes.get.failure,
    payload: messages
  }
}

const get_payment = (payment_id) => {
  return function (dispatch) {
    // Before Request
    dispatch(get_payment_request())

    // Request
    axios.get(
      formatRoute(PAYMENTS_ROUTES.get, {id: payment_id})
    ).then( response => {
      // success
      dispatch( get_payment_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching payment."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( get_payment_failure(errors))
    })
  }
}

const get_payment_by_position = (skip=0, filters={}, sort='', order='') => {
  return function (dispatch) {
    // Before Request
    dispatch(get_payment_request())

    // Request
    axios.get(
      PAYMENTS_ROUTES.get_payment_by_position,
      {
        params: {
          sort: sort,
          order: order,
          filters: filters,
          skip: skip
        }
      }
    ).then( response => {
      // success
      dispatch( get_payment_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching payment."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( get_payment_failure(errors))
    })
  }
}


export {
  get_payment,
  get_payment_by_position
}



// WEBPACK FOOTER //
// ./src/js/actions/payments/get.js